import Container from '@/components/Container'
import HtmlContent from '@/components/HtmlContent'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { mailIcon, urbanLogo } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import style from '../styles/club.module.scss'

const Head = (): React.ReactElement => {
  const page = usePage()
  const { object } = page?.init_state

  return (
    <Container className={style.head_container}>
      <div className={style.head_wrap}>
        <GxIcon src={urbanLogo} className={style.head__logo} />
        <div>
          <Title type='h1' className={style.head__title}>
            {object.title}
          </Title>

          <HtmlContent content={object.detail} className={style.head__text} />

          <a href='mailto:obuchenie@fondrt.ru' className={style.head__link}>
            <GxIcon src={mailIcon} className={style.head__link_icon} />
            obuchenie@fondrt.ru
          </a>
        </div>
      </div>
    </Container>
  )
}

export default Head
